const Apple = ({props}) => (
  <svg
    fill="#ffffff"
    stroke="#ffffff"
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20,12.426C20,16.539,17.493,22,14.4,22a4.285,4.285,0,0,1-1.6-.316,2.118,2.118,0,0,0-1.592,0A4.285,4.285,0,0,1,9.6,22C6.507,22,4,16.539,4,12.426S6.507,5.317,9.6,5.317a4.271,4.271,0,0,1,1.588.321A4.643,4.643,0,0,1,16,2a1,1,0,0,1,0,2,2.685,2.685,0,0,0-2.629,1.457,4.158,4.158,0,0,1,1.029-.14C17.493,5.317,20,8.314,20,12.426Z" />
  </svg>
);

export default Apple;
